<div class="min-h-screen rounded-lg bg-white dark:bg-black p-4">
  <div class="mb-4">
    <p-breadcrumb
      [model]="displayBreadcrumbs()"
      styleClass="rounded-lg border border-gray-200 dark:border-gray-800"
    >
      <ng-template #separator>
        <i class="pi pi-chevron-right text-primary-400 text-sm mx-2"></i>
      </ng-template>
      <ng-template #item let-item>
        @if (item.routerLink && !item.disabled) {
          <a
            [routerLink]="item.routerLink"
            class="flex items-center text-primary-600 hover:text-primary-800 dark:hover:text-primary-500 dark:text-primary-300 transition-colors duration-200"
          >
            @if (item.icon) {
              <i [class]="item.icon + ' mr-2'"></i>
            }
            <span>{{ item.label | translate }}</span>
          </a>
        } @else {
          <span class="flex items-center text-primary-600 dark:text-primary-300">
            @if (item.icon) {
              <i [class]="item.icon + ' mr-2'"></i>
            }
            <span class="font-medium">{{ item.label | translate }}</span>
          </span>
        }
      </ng-template>
    </p-breadcrumb>
  </div>

  <div class="mb-6 flex flex-col gap-4">
    <div class="flex items-start gap-4">
      <div
        class="flex size-16 shrink-0 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/40"
      >
        <i class="pi pi-chart-line text-primary-500 dark:text-primary-300 !text-3xl"></i>
      </div>
      <div>
        <h1 class="text-3xl font-bold text-gray-900 dark:text-white">
          Estado General de Integraciones
        </h1>
        <p class="mt-2 max-w-3xl text-sm text-gray-600 dark:text-gray-400 md:text-base">
          Visibilidad en tiempo real del orquestador para detectar errores, monitorear volumen y
          navegar al detalle transaccional.
        </p>
      </div>
    </div>
  </div>

  <div
    class="mb-6 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800"
  >
    <div
      class="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700"
    >
      <div class="flex items-center gap-2">
        <i class="pi pi-search text-sm text-gray-500 dark:text-gray-400"></i>
        <span class="text-sm font-medium text-gray-800 dark:text-gray-100">Filtros</span>
        <span
          class="inline-flex items-center rounded-full bg-primary-100 px-2 py-0.5 text-[10px] font-semibold text-primary-700 dark:bg-primary-900/30 dark:text-primary-300"
        >
          {{ activeFiltersCount() }} activos
        </span>
      </div>

      <button
        (click)="clearFilters()"
        class="flex h-7 items-center gap-1.5 rounded-md px-2 text-xs text-gray-600 transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
        type="button"
      >
        <i class="pi pi-filter-slash text-[11px]"></i>
        <span>Limpiar</span>
      </button>
    </div>

    <div class="p-4">
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4 xl:items-end">
        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-medium text-gray-500 dark:text-gray-400" for="workflowFilter">
            Workflow
          </label>
          <p-select
            (onChange)="onWorkflowChange($event.value)"
            [ngModel]="workflowId()"
            [filter]="true"
            [options]="workflowOptions()"
            [showClear]="true"
            appendTo="body"
            class="w-full"
            filterPlaceholder="Buscar workflow..."
            inputId="workflowFilter"
            optionLabel="name"
            optionValue="id"
            placeholder="Todos los workflows"
          ></p-select>
        </div>

        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-medium text-gray-500 dark:text-gray-400" for="rangeFilter">
            Rango
          </label>
          <p-select
            (onChange)="onRangeChange($event.value)"
            [ngModel]="selectedRange()"
            [options]="rangeOptions"
            appendTo="body"
            class="w-full"
            inputId="rangeFilter"
            optionLabel="label"
            optionValue="value"
            placeholder="Rango"
          ></p-select>
        </div>

        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-medium text-gray-500 dark:text-gray-400" for="statusFilter">
            Estado
          </label>
          <p-select
            (onChange)="onStatusChange($event.value)"
            [ngModel]="selectedStatus()"
            [options]="statusOptions"
            appendTo="body"
            class="w-full"
            inputId="statusFilter"
            optionLabel="label"
            optionValue="value"
            placeholder="Estado"
          >
            <ng-template let-option pTemplate="item">
              <div class="flex items-center gap-2">
                <i [class]="option.icon" class="text-sm text-slate-500"></i>
                <span>{{ option.label }}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="selectedItem">
              <div class="flex items-center gap-2">
                <i [class]="selectedStatusOption().icon" class="text-sm text-slate-500"></i>
                <span>{{ selectedStatusOption().label }}</span>
              </div>
            </ng-template>
          </p-select>
        </div>

        <div class="flex flex-col gap-1.5">
          <label
            aria-hidden="true"
            class="text-xs font-medium text-transparent select-none"
            for="action"
          >
            Acción
          </label>
          <p-button
            (onClick)="loadDashboard()"
            [disabled]="loading()"
            [loading]="loading()"
            icon="pi pi-sync"
            id="action"
            label="Actualizar"
            severity="contrast"
            styleClass="w-full"
          ></p-button>
        </div>
      </div>
    </div>
  </div>

  @if (loading()) {
    <div class="flex min-h-[420px] flex-col items-center justify-center gap-4">
      <p-progressSpinner></p-progressSpinner>
      <div class="text-center">
        <p class="text-lg font-semibold text-gray-900 dark:text-white">
          Cargando dashboard de integraciones
        </p>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Estamos preparando el resumen general y la estructura del tablero.
        </p>
      </div>
    </div>
  } @else if (errorMessage()) {
    <div
      class="flex min-h-[420px] flex-col items-center justify-center gap-4 rounded-[1.25rem] border border-dashed border-slate-300/90 bg-white/70 p-8 dark:border-slate-700/90 dark:bg-slate-900/35"
    >
      <div
        class="inline-flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-full bg-red-100/85 text-[1.75rem] text-red-600"
      >
        <i class="pi pi-exclamation-triangle"></i>
      </div>
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white">
        No pudimos cargar el panel
      </h2>
      <p class="max-w-xl text-center text-sm text-gray-600 dark:text-gray-400">
        {{ errorMessage() }}
      </p>
      <p-button
        (onClick)="loadDashboard()"
        icon="pi pi-refresh"
        label="Reintentar"
        severity="contrast"
      ></p-button>
    </div>
  } @else if (!hasData()) {
    <div
      class="flex min-h-[420px] flex-col items-center justify-center gap-4 rounded-[1.25rem] border border-dashed border-slate-300/90 bg-white/70 p-8 dark:border-slate-700/90 dark:bg-slate-900/35"
    >
      <div
        class="inline-flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-full bg-blue-100/85 text-[1.75rem] text-blue-600"
      >
        <i class="pi pi-inbox"></i>
      </div>
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white">
        No hay datos para el período seleccionado
      </h2>
      <p class="max-w-xl text-center text-sm text-gray-600 dark:text-gray-400">
        Ajusta el rango, el estado o la búsqueda del workflow para cargar información del tablero.
      </p>
    </div>
  } @else {
    <div class="space-y-6">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
        <!-- Total transacciones -->
        <p-card
          class="overflow-hidden rounded-2xl border border-gray-200/90 shadow-[0_14px_32px_rgba(15,23,42,0.05)]"
        >
          <div class="space-y-2">
            <p class="text-sm font-medium text-gray-500 dark:text-gray-400">
              Transacciones totales
            </p>
            <p class="text-4xl font-bold text-gray-900 dark:text-white">
              {{ dashboardData()?.summary?.total_transactions | number }}
            </p>
            <div class="flex items-center gap-3 text-xs text-gray-500 dark:text-gray-400">
              <span class="flex items-center gap-1">
                <span class="inline-block h-2 w-2 rounded-full bg-emerald-500"></span>
                {{ dashboardData()?.summary?.success_rate }}% éxito
              </span>
              <span class="flex items-center gap-1">
                <span class="inline-block h-2 w-2 rounded-full bg-red-500"></span>
                {{ dashboardData()?.summary?.error_rate }}% error
              </span>
            </div>
          </div>
        </p-card>

        <!-- Transacciones exitosas -->
        <p-card
          class="overflow-hidden rounded-2xl border border-gray-200/90 shadow-[0_14px_32px_rgba(15,23,42,0.05)]"
        >
          <div class="space-y-2">
            <p class="text-sm font-medium text-gray-500 dark:text-gray-400">
              Transacciones exitosas
            </p>
            <p class="text-4xl font-bold text-emerald-600 dark:text-emerald-400">
              {{ dashboardData()?.summary?.success | number }}
            </p>
            <div class="flex items-center gap-3 text-xs text-gray-500 dark:text-gray-400">
              <span>
                Omitidas:
                <strong class="text-amber-600 dark:text-amber-400">
                  {{ dashboardData()?.summary?.skipped | number }}
                </strong>
              </span>
              <span>
                Procesando:
                <strong class="text-blue-600 dark:text-blue-400">
                  {{ dashboardData()?.summary?.processing | number }}
                </strong>
              </span>
            </div>
          </div>
        </p-card>

        <!-- Transacciones fallidas -->
        <p-card
          class="overflow-hidden rounded-2xl border border-gray-200/90 shadow-[0_14px_32px_rgba(15,23,42,0.05)]"
        >
          <div class="space-y-2">
            <p class="text-sm font-medium text-gray-500 dark:text-gray-400">
              Transacciones con error
            </p>
            <p class="text-4xl font-bold text-rose-600 dark:text-rose-400">
              {{ dashboardData()?.summary?.error | number }}
            </p>
            <div class="flex items-center gap-3 text-xs text-gray-500 dark:text-gray-400">
              <span>
                Redirigidas:
                <strong class="text-violet-600 dark:text-violet-400">
                  {{ dashboardData()?.summary?.redirected | number }}
                </strong>
              </span>
              <span>
                Tasa:
                <strong class="text-rose-600 dark:text-rose-400">
                  {{ dashboardData()?.summary?.error_rate }}%
                </strong>
              </span>
            </div>
          </div>
        </p-card>

        <!-- Workflows con incidencias -->
        <p-card
          class="overflow-hidden rounded-2xl border border-gray-200/90 shadow-[0_14px_32px_rgba(15,23,42,0.05)]"
        >
          <div class="space-y-2">
            <p class="text-sm font-medium text-gray-500 dark:text-gray-400">
              Workflows con incidencias
            </p>
            <p class="text-4xl font-bold text-amber-600 dark:text-amber-400">
              {{ dashboardData()?.summary?.workflows_with_incidents | number }}
            </p>
            <div class="flex items-center gap-3 text-xs text-gray-500 dark:text-gray-400">
              <span>
                Con errores:
                <strong class="text-rose-600 dark:text-rose-400">
                  {{ dashboardData()?.summary?.workflows_with_error | number }}
                </strong>
              </span>
              <span>
                Con omisiones:
                <strong class="text-amber-600 dark:text-amber-400">
                  {{ dashboardData()?.summary?.workflows_with_skipped | number }}
                </strong>
              </span>
            </div>
          </div>
        </p-card>
      </div>

      <div class="grid grid-cols-1 gap-6 xl:grid-cols-[minmax(0,2fr)_minmax(320px,1fr)]">
        <p-card
          class="overflow-hidden rounded-2xl border border-gray-200/90 shadow-[0_14px_32px_rgba(15,23,42,0.05)]"
        >
          <ng-template pTemplate="header">
            <div
              class="flex items-center justify-between border-b border-gray-200 p-4 dark:border-gray-800"
            >
              <div>
                <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                  Volumen de transacciones por hora
                </h3>
                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
                  Distribución horaria por estado en el período seleccionado.
                </p>
              </div>
              <span
                class="rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700 dark:bg-primary-900/40 dark:text-primary-300"
              >
                {{ dashboardData()?.volume?.length }} puntos
              </span>
            </div>
          </ng-template>

          <div class="min-h-[320px]">
            @if (volumeChartData()) {
              <p-chart
                [data]="volumeChartData()!"
                [options]="volumeChartOptions"
                class="min-h-[440px] w-full"
                height="320"
                type="bar"
              ></p-chart>
            }
          </div>
        </p-card>

        <p-card
          class="overflow-hidden rounded-2xl border border-gray-200/90 shadow-[0_14px_32px_rgba(15,23,42,0.05)]"
        >
          <ng-template pTemplate="header">
            <div
              class="flex items-center justify-between border-b border-gray-200 p-4 dark:border-gray-800"
            >
              <div>
                <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                  Distribución de estados
                </h3>
                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
                  Proporción de transacciones por estado.
                </p>
              </div>
              <span
                class="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-300"
              >
                {{ dashboardData()?.distribution?.total }} registros
              </span>
            </div>
          </ng-template>

          <div class="min-h-[320px]">
            @if (distributionChartData()) {
              <p-chart
                [data]="distributionChartData()!"
                [options]="doughnutChartOptions"
                class="w-full"
                height="440"
                type="doughnut"
              ></p-chart>
            }
          </div>
        </p-card>
      </div>

      <div
        class="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900"
      >
        <div
          class="flex flex-col gap-3 border-b border-gray-200 p-4 dark:border-gray-700 md:flex-row md:items-center md:justify-between"
        >
          <div>
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
              Desglose por integración
            </h3>
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Vista consolidada por workflow para navegar directo al monitoreo.
            </p>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-sm text-gray-500 dark:text-gray-400">
              {{ dashboardData()?.integrations?.length }} workflows
            </span>
            <p-button
              (onClick)="clearFilters()"
              icon="pi pi-filter-slash"
              label="Limpiar filtros"
              severity="secondary"
              variant="outlined"
            />
          </div>
        </div>

        <div
          class="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-5 py-3 dark:border-gray-700 dark:bg-gray-800/70"
        >
          <p class="text-xs text-gray-500 dark:text-gray-400">
            Mostrando
            <span class="font-semibold text-gray-900 dark:text-gray-100">
              {{ dashboardData()?.integrations?.length || 0 }}
            </span>
            {{ (dashboardData()?.integrations?.length || 0) === 1 ? 'workflow' : 'workflows' }}
          </p>
        </div>

        <p-table
          [currentPageReportTemplate]="'Mostrando {first} - {last} de {totalRecords} workflows'"
          [paginatorDropdownAppendTo]="'body'"
          [paginator]="true"
          [rowHover]="true"
          [rowsPerPageOptions]="integrationRowsPerPageOptions"
          [rows]="integrationRows"
          [showCurrentPageReport]="true"
          [tableStyle]="{ 'min-width': '70rem' }"
          [totalRecords]="dashboardData()?.integrations?.length || 0"
          [value]="dashboardData()?.integrations || []"
          responsiveLayout="scroll"
        >
          <ng-template #header>
            <tr class="bg-gray-50 hover:bg-gray-50 dark:bg-gray-800/70 dark:hover:bg-gray-800/70">
              <th
                class="w-24 pl-5 text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
                scope="col"
              >
                ID
              </th>
              <th
                class="min-w-[260px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
                scope="col"
              >
                Workflow
              </th>
              <th
                class="min-w-[150px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
                scope="col"
              >
                Estado
              </th>
              <th
                class="min-w-[160px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
                scope="col"
              >
                Transacciones
              </th>
              <th
                class="min-w-[210px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
                scope="col"
              >
                Última ejecución
              </th>
              <th
                class="min-w-[120px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
                scope="col"
              >
                Tendencia
              </th>
              <th
                class="min-w-[120px] pr-5 text-right text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
                scope="col"
              >
                Acciones
              </th>
            </tr>
          </ng-template>

          <ng-template #body let-integration let-rowIndex="rowIndex">
            <tr
              [ngClass]="
                rowIndex % 2 === 0
                  ? 'bg-white dark:bg-gray-900'
                  : 'bg-gray-50/60 dark:bg-gray-800/30'
              "
              class="transition-colors hover:bg-primary-50/40 dark:hover:bg-primary-900/10"
            >
              <td class="pl-5 py-4">
                <span
                  class="rounded-md bg-gray-100 px-2 py-0.5 font-mono text-xs font-semibold text-gray-500 dark:bg-gray-800 dark:text-gray-300"
                >
                  #{{ integration.workflow_id }}
                </span>
              </td>

              <td class="py-4">
                <div class="flex flex-col gap-1">
                  <span class="text-sm font-medium text-gray-900 dark:text-gray-100">
                    {{ integration.workflow_name }}
                  </span>
                  <span
                    [pTooltip]="integration.workflow_description || 'Sin descripción disponible'"
                    class="max-w-[430px] truncate text-xs text-gray-500 dark:text-gray-400"
                    tooltipPosition="top"
                  >
                    {{ integration.workflow_description || 'Sin descripción disponible' }}
                  </span>
                </div>
              </td>

              <td class="py-4">
                <span
                  [ngClass]="getIntegrationStatusClass(integration.current_status)"
                  class="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium"
                >
                  <span class="h-1.5 w-1.5 rounded-full bg-current opacity-70"></span>
                  {{ getStatusLabel(integration.current_status) }}
                </span>
              </td>

              <td class="py-4">
                <span class="text-sm font-medium text-gray-700 dark:text-gray-200">
                  {{ integration.total_transactions }}
                </span>
              </td>

              <td class="py-4">
                <div class="flex flex-wrap items-center gap-2">
                  <span
                    class="inline-flex items-center gap-1.5 rounded-md border border-indigo-200 bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 dark:border-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300"
                  >
                    <i class="pi pi-calendar text-[10px]"></i>
                    {{ integration.last_execution | date: 'dd/MM/yyyy' }}
                  </span>
                  <span
                    class="inline-flex items-center gap-1.5 rounded-md border border-gray-200 bg-gray-100 px-2 py-1 text-xs font-medium text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
                  >
                    <i class="pi pi-clock text-[10px]"></i>
                    {{ integration.last_execution | date: 'HH:mm:ss' }}
                  </span>
                </div>
              </td>

              <td class="py-4">
                @if (integration.tendency_label !== null) {
                  <span
                    [ngClass]="getTrendClass(integration.tendency_pct)"
                    class="inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold"
                  >
                    {{ integration.tendency_label }}
                  </span>
                } @else {
                  <span class="text-xs text-gray-400 dark:text-gray-600">—</span>
                }
              </td>

              <td class="py-4 pr-5">
                <div class="flex items-center justify-end">
                  <p-button
                    (onClick)="goToWorkflowMonitoring(integration.workflow_id)"
                    icon="pi pi-arrow-right"
                    label="Ver"
                    severity="secondary"
                    size="small"
                    variant="text"
                  />
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template #emptymessage>
            <tr>
              <td class="py-16 text-center text-sm text-gray-500 dark:text-gray-400" colspan="7">
                No se encontraron integraciones con los filtros aplicados.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</div>
